const pending: File[] = [];

// WHY: the camera opens from the capture menu's own tap (browsers allow file pickers only on a gesture); the photos then wait for the composer on the Logbook page.
export const handOffPhotos = (files: readonly File[]): void => {
  pending.splice(0, pending.length, ...files);
};

export const handedPhotos = (): readonly File[] => [...pending];

export const clearHandedPhotos = (): void => {
  pending.length = 0;
};
